import QuestionsAndAnswers, {
  QuestionsAndAnswersProps,
} from "./QuestionsAndAnswers";

export { QuestionsAndAnswers, QuestionsAndAnswersProps };

export default QuestionsAndAnswers;
